import { Component, Element, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-search-form',
  styleUrl: 'search-form.css',
  shadow: true,
})
export class SearchForm {
  @Element() host: HTMLElement;

  @Prop() action        : string = '/';
  @Prop() method        : string = 'get';
  @Prop() placeholder   : string = 'Type something to search';
  @Prop() inputName     : string = 's';
  @Prop() closeIconColor: string = 'var(--cwc-color-secondary-900, #242424)';

  hideForm = () => {
    this.host.classList.add('hidden');
    if( document.querySelector('body #modal-backDrop') ){
      document.querySelector('body #modal-backDrop').remove();
    }
  }

  render() {
    return (
      <Host>
        <form action={ this.action } method={this.method}>
          <input type="text" name={this.inputName} class="search-field" placeholder={this.placeholder} />
          <span class="search-close" onClick={this.hideForm}>
            <svg class="fa-xmark" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="">
              <path fill={this.closeIconColor} d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
            </svg>
          </span>
        </form>
      </Host>
    );
  }

}
